import React, { useEffect, useState } from 'react'
import { Card, Form, Button, Modal, Row, Col } from 'react-bootstrap'
import DataTable from 'react-data-table-component'
import ControlContrasenasService from '../../../Services/Catalogos/CatSistemas'
import { MsgInformativo } from '../../../Utils/Toast/msgInformativo'
import {
    ControlContrasenaGeneral,
    ActualizarContrasenaGeneralDto
} from './DTO/DTOActualizarContrasenasGenerales'
import { CatTipoContrasenaDto } from './DTO/DTOCatTipoContrasena'
import ExcelJS from 'exceljs'
import { saveAs } from 'file-saver'
import { BsSearch, BsFileEarmarkExcel, BsChatLeftTextFill } from "react-icons/bs";

const ControlContrasenasGenerales: React.FC = () => {
    const [lista, setLista] = useState<ControlContrasenaGeneral[]>([])
    const [filtrados, setFiltrados] = useState<ControlContrasenaGeneral[]>([])
    const [filtro, setFiltro] = useState('')

    const [showModal, setShowModal] = useState(false)
    const [modoEditar, setModoEditar] = useState(false)

    const [nombre, setNombre] = useState('')
    const [tipoContrasena, setTipoContrasena] = useState('')
    const [contrasena, setContrasena] = useState('')
    const [fechaAlta, setFechaAlta] = useState('')

    const [mostrarPasswords, setMostrarPasswords] = useState<{ [key: number]: boolean }>({})

    const [showMsg, setShowMsg] = useState(false)
    const [msg, setMsg] = useState('')
    const [header, setHeader] = useState('')

    const [tiposContrasena, setTiposContrasena] = useState<CatTipoContrasenaDto[]>([])
const [nuevoTipoContrasena, setNuevoTipoContrasena] = useState("")
const [editandoTipoId, setEditandoTipoId] = useState<number | null>(null)
const [nombreTipoEditando, setNombreTipoEditando] = useState("")


   useEffect(() => {
    cargarDatos()
    cargarTiposContrasena()
}, [])

const cargarTiposContrasena = async () => {
    try {
        const response = await ControlContrasenasService.GetTiposContrasena(true)
        setTiposContrasena(response.data)
    } catch {
        mostrarMensaje("Error", "Error al cargar tipos de contraseña")
    }
}

const agregarTipoContrasena = async () => {
    const valor = nuevoTipoContrasena.trim().toUpperCase()

    if (!valor) {
        mostrarMensaje("Advertencia", "Escriba un tipo de contraseña")
        return
    }

    try {
        await ControlContrasenasService.InsertarTipoContrasena({ nombre: valor })

        setNuevoTipoContrasena("")
        setTipoContrasena("")
        await cargarTiposContrasena()

        mostrarMensaje("Éxito", "Tipo agregado correctamente")
    } catch {
        mostrarMensaje("Error", "Error al agregar tipo de contraseña")
    }
}

const desactivarTipoContrasena = async (id: number) => {
    try {
        await ControlContrasenasService.DesactivarTipoContrasena(id)
        setTipoContrasena("")
        await cargarTiposContrasena()

        mostrarMensaje("Éxito", "Tipo desactivado correctamente")
    } catch {
        mostrarMensaje("Error", "Error al desactivar tipo")
    }
}

const iniciarEditarTipo = (tipo: CatTipoContrasenaDto) => {
    setEditandoTipoId(tipo.id)
    setNombreTipoEditando(tipo.nombre)
}

const cancelarEditarTipo = () => {
    setEditandoTipoId(null)
    setNombreTipoEditando("")
}

const guardarEditarTipo = async () => {
    if (!editandoTipoId || !nombreTipoEditando.trim()) {
        mostrarMensaje("Advertencia", "Escriba el nombre del tipo")
        return
    }

    try {
        await ControlContrasenasService.ActualizarTipoContrasena(editandoTipoId, {
            nombre: nombreTipoEditando.trim().toUpperCase()
        })

        cancelarEditarTipo()
        setTipoContrasena("")
        await cargarTiposContrasena()

        mostrarMensaje("Éxito", "Tipo actualizado correctamente")
    } catch { 
        mostrarMensaje("Error", "Error al actualizar tipo")
    }
}






    const cargarDatos = async () => {
        try {
            const response = await ControlContrasenasService.GetAllContrasenasGenerales()
            setLista(response.data)
            setFiltrados(response.data)
        } catch {
            mostrarMensaje('Error', 'Error al cargar contraseñas generales')
        }
    }

    const mostrarMensaje = (titulo: string, mensaje: string) => {
        setHeader(titulo)
        setMsg(mensaje)
        setShowMsg(true)
    }

    const filtrar = (e: any) => {
        const value = e.target.value
        setFiltro(value)

        const data = lista.filter(x =>
            x.nombre.toLowerCase().includes(value.toLowerCase()) ||
            x.tipoContrasena.toLowerCase().includes(value.toLowerCase()) ||
            x.estatus.toLowerCase().includes(value.toLowerCase())
        )

        setFiltrados(data)
    }

    const abrirNuevo = () => {
        setModoEditar(false)
        setNombre('')
        setTipoContrasena('')
        setContrasena('')
        setFechaAlta('')
        setShowModal(true)
        setNuevoTipoContrasena("")
setEditandoTipoId(null)
setNombreTipoEditando("")
    }


    const abrirInsertarNuevoPorNombre = (row: ControlContrasenaGeneral) => {
    setModoEditar(false)
    setNombre(row.nombre)
    setTipoContrasena('')
    setContrasena('')
    setFechaAlta('')
    setShowModal(true)

    setNuevoTipoContrasena("")
    setEditandoTipoId(null)
    setNombreTipoEditando("")
}


    const abrirEditar = (row: ControlContrasenaGeneral) => {
        setModoEditar(true)
        setNombre(row.nombre)
        setTipoContrasena(row.tipoContrasena)
        setContrasena('')
        setFechaAlta('')
        setShowModal(true)
    }

    const guardar = async () => {
        if (!nombre.trim() || !tipoContrasena.trim() || !contrasena.trim()) {
            mostrarMensaje('Advertencia', 'Complete nombre, tipo y contraseña')
            return
        }

        if (!modoEditar && !fechaAlta) {
            mostrarMensaje('Advertencia', 'La fecha de alta es obligatoria')
            return
        }

        const data: ActualizarContrasenaGeneralDto = {
            nombre: nombre.trim().toUpperCase(),
            tipoContrasena: tipoContrasena.trim().toUpperCase(),
            contrasena,
            fechaAlta: modoEditar ? null : fechaAlta
        }

        try {
            await ControlContrasenasService.ActualizarContrasenaGeneral(data)

            mostrarMensaje('Éxito', 'Contraseña guardada correctamente')
            setShowModal(false)
            await cargarDatos()
        } catch {
            mostrarMensaje('Error', 'Error al guardar contraseña')
        }
    }

    const eliminar = async (row: ControlContrasenaGeneral) => {
        if (!window.confirm('¿Seguro que deseas eliminar esta contraseña?')) return

        try {
            await ControlContrasenasService.EliminarContrasenaGeneral(
                row.nombre,
                row.tipoContrasena
            )

            mostrarMensaje('Eliminado', 'Contraseña eliminada correctamente')
            await cargarDatos()
        } catch {
            mostrarMensaje('Error', 'Error al eliminar contraseña')
        }
    }

    const toggleMostrarPassword = (id: number) => {
        setMostrarPasswords(prev => ({
            ...prev,
            [id]: !prev[id]
        }))
    }

    const descargarExcel = async () => {
    const workbook = new ExcelJS.Workbook()
    const worksheet = workbook.addWorksheet('Contraseñas Generales')

    worksheet.columns = [
        { header: 'Nombre', key: 'nombre', width: 30 },
        { header: 'Tipo Contraseña', key: 'tipoContrasena', width: 22 },
        
        { header: 'Fecha Alta', key: 'fechaAlta', width: 15 },
        { header: 'Última Actualización', key: 'fechaUltimaActualizacion', width: 22 },
        { header: 'Fecha Vencimiento', key: 'fechaVencimiento', width: 18 },
        { header: 'Estatus', key: 'estatus', width: 15 }
    ]

    const datosOrdenados = [...filtrados].sort((a, b) =>
        a.nombre.localeCompare(b.nombre)
    )

    datosOrdenados.forEach(item => {
        worksheet.addRow({
            nombre: item.nombre,
            tipoContrasena: item.tipoContrasena,
            
            fechaAlta: item.fechaAlta,
            fechaUltimaActualizacion: item.fechaUltimaActualizacion || '',
            fechaVencimiento: item.fechaVencimiento,
            estatus: item.estatus
        })
    })

    worksheet.getRow(1).font = { bold: true, color: { argb: 'FFFFFFFF' } }
    worksheet.getRow(1).fill = {
        type: 'pattern',
        pattern: 'solid',
        fgColor: { argb: 'FF1F4E78' }
    }

    worksheet.getRow(1).alignment = {
        vertical: 'middle',
        horizontal: 'center'
    }

    worksheet.eachRow((row) => {
        row.eachCell((cell) => {
            cell.border = {
                top: { style: 'thin' },
                left: { style: 'thin' },
                bottom: { style: 'thin' },
                right: { style: 'thin' }
            }
        })
    })

    worksheet.autoFilter = {
        from: 'A1',
        to: 'F1'
    }

    worksheet.views = [{ state: 'frozen', ySplit: 1 }]

    const buffer = await workbook.xlsx.writeBuffer()
    const blob = new Blob([buffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    })

    saveAs(blob, `Control_Contrasenas_Generales_${new Date().toISOString().slice(0, 10)}.xlsx`)
}










    const columnas = [
        {
            name: 'Nombre',
            selector: (row: ControlContrasenaGeneral) => row.nombre,
            sortable: true,
            wrap: true
        },
        {
            name: 'Tipo',
            selector: (row: ControlContrasenaGeneral) => row.tipoContrasena,
            sortable: true
        },
        {
            name: 'Contraseña',
            cell: (row: ControlContrasenaGeneral) => (
                <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                    <span>
                        {mostrarPasswords[row.id] ? row.contrasenaPlana : '••••••••'}
                    </span>

                    <Button
                        size="sm"
                        variant="outline-secondary"
                        onClick={() => toggleMostrarPassword(row.id)}
                    >
                        👁
                    </Button>
                </div>
            )
        },
        {
            name: 'Fecha Alta',
            selector: (row: ControlContrasenaGeneral) => row.fechaAlta,
            sortable: true,
            width: '140px'
        },
        {
            name: 'Última Actualización',
            selector: (row: ControlContrasenaGeneral) => row.fechaUltimaActualizacion || '',
            sortable: true,
            width: '180px'
        },
        {
            name: 'Vencimiento',
            selector: (row: ControlContrasenaGeneral) => row.fechaVencimiento,
            sortable: true,
            width: '150px'
        },
        {
            name: 'Estatus',
            cell: (row: ControlContrasenaGeneral) => (
                <span
                    className={
                        row.estatus === 'AL DIA'
                            ? 'badge bg-success'
                            : row.estatus === 'POR VENCER'
                            ? 'badge bg-warning'
                            : 'badge bg-danger'
                    }
                >
                    {row.estatus}
                </span>
            ),
            sortable: true
        },
       


        {
    name: 'Acciones',
    cell: (row: ControlContrasenaGeneral) => (
        <div className="d-flex gap-1">
            <Button
                size="sm"
                variant="outline-success"
                title="Insertar nuevo con este nombre"
                onClick={() => abrirInsertarNuevoPorNombre(row)}
            >
                ➕
            </Button>

            <Button
                size="sm"
                variant="outline-primary"
                title="Editar"
                onClick={() => abrirEditar(row)}
            >
                ✏️
            </Button>

            <Button
                size="sm"
                variant="outline-danger"
                title="Eliminar"
                onClick={() => eliminar(row)}
            >
                🗑️
            </Button>
        </div>
    ),
    width: '130px'
}
    ]




    return (
        <div className="container-fluid mt-3">
            <Card>
                <Card.Body>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        

                         <Button size="sm" variant="outline-success" onClick={descargarExcel}>
      <BsFileEarmarkExcel /> Excel
    </Button>

    <Button size="sm" variant="success" onClick={abrirNuevo}>
        + Nueva
    </Button>
                    </div>

                    <Form.Control
                        type="text"
                        placeholder="Buscar por nombre, tipo o estatus..."
                        value={filtro}
                        onChange={filtrar}
                        className="mb-3"
                        autoComplete="off"
                    />

                    <DataTable
                        columns={columnas}
                        data={filtrados}
                        pagination
                        highlightOnHover
                        dense
                    />
                </Card.Body>
            </Card>

            <Modal show={showModal} onHide={() => setShowModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        {modoEditar ? 'Actualizar Contraseña' : 'Nueva Contraseña General'}
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <Row>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>Nombre / Referencia</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={nombre}
                                    onChange={(e) => setNombre(e.target.value.toUpperCase())}
                                    disabled={modoEditar}
                                    autoComplete="off"
                                />
                            </Form.Group>
                        </Col>

                      <Form.Group className="mb-3">
    <Row className="align-items-end">
        <Col md={8}>
            <Form.Label>Tipo Contraseña</Form.Label>

            <Form.Select
                value={tipoContrasena}
                onChange={(e) => setTipoContrasena(e.target.value)}
                disabled={modoEditar}
                autoComplete="off"
            >
                <option value="">Seleccione tipo</option>

                {tiposContrasena.map((tipo) => (
                    <option key={tipo.id} value={tipo.nombre}>
                        {tipo.nombre}
                    </option>
                ))}
            </Form.Select>
        </Col>

        {!modoEditar && (
            <Col md={4}>
                <Form.Label>Opciones</Form.Label>

                <div className="d-flex gap-1">
                    <Button
                        size="sm"
                        variant="warning"
                        disabled={!tipoContrasena}
                        onClick={() => {
                            const tipo = tiposContrasena.find(x => x.nombre === tipoContrasena)
                            if (tipo) iniciarEditarTipo(tipo)
                        }}
                    >
                        Editar
                    </Button>

                    <Button
                        size="sm"
                        variant="danger"
                        disabled={!tipoContrasena}
                        onClick={() => {
                            const tipo = tiposContrasena.find(x => x.nombre === tipoContrasena)
                            if (tipo) desactivarTipoContrasena(tipo.id)
                        }}
                    >
                        Quitar
                    </Button>
                </div>
            </Col>
        )}
    </Row>

    {!modoEditar && (
        <div className="d-flex gap-2 mt-2">
            <Form.Control
                size="sm"
                type="text"
                placeholder={editandoTipoId ? "Editar tipo" : "Nuevo tipo"}
                value={editandoTipoId ? nombreTipoEditando : nuevoTipoContrasena}
                onChange={(e) => {
                    const valor = e.target.value.toUpperCase()

                    if (editandoTipoId) {
                        setNombreTipoEditando(valor)
                    } else {
                        setNuevoTipoContrasena(valor)
                    }
                }}
                autoComplete="off"
            />

            {editandoTipoId ? (
                <>
                    <Button size="sm" variant="success" onClick={guardarEditarTipo}>
                        Guardar
                    </Button>

                    <Button size="sm" variant="secondary" onClick={cancelarEditarTipo}>
                        Cancelar
                    </Button>
                </>
            ) : (
                <Button size="sm" variant="secondary" onClick={agregarTipoContrasena}>
                    Agregar
                </Button>
            )}
        </div>
    )}
</Form.Group>

                        {!modoEditar && (
                            <Col md={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Fecha Alta</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={fechaAlta}
                                        onChange={(e) => setFechaAlta(e.target.value)}
                                    />
                                </Form.Group>
                            </Col>
                        )}

                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>Contraseña</Form.Label>
                                <Form.Control
                                    type="password"
                                    value={contrasena}
                                    onChange={(e) => setContrasena(e.target.value)}
                                    autoComplete="new-password"
                                    name="contrasenaGeneralNueva"
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </Modal.Body>

                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cancelar
                    </Button>

                    <Button variant="primary" onClick={guardar}>
                        Guardar
                    </Button>
                </Modal.Footer>
            </Modal>

            <MsgInformativo
                show={showMsg}
                msg={msg}
                header={header}
                msgColor="primary"
                closeToast={() => setShowMsg(false)}
            />
        </div>
    )
}

export default ControlContrasenasGenerales